import React from "react";
import { Radio, Users, Maximize2, Play } from "lucide-react";
import { useRoom } from "@/context/RoomContext";
import LobbyDialog from "@/components/LobbyDialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function LobbyDock() {
  const { activeRoom: room, openLobby, setOpenLobby } = useRoom();
  if (!room) return null;

  return (
    <>
      {!openLobby && (
        <div data-testid="lobby-dock"
          className="fixed bottom-20 left-1/2 -translate-x-1/2 lg:bottom-4 z-40 flex items-center gap-3 rounded-full border border-[hsl(var(--primary))]/30 bg-[hsl(var(--card))]/95 backdrop-blur-xl shadow-2xl shadow-black/30 px-4 py-2.5 max-w-[92vw]">
          <span className="relative flex h-2.5 w-2.5 shrink-0">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
          </span>
          <span className="text-xl shrink-0">{room.game_cover}</span>
          <div className="min-w-0 hidden sm:block leading-tight">
            <div className="text-sm font-bold truncate max-w-[160px]">{room.game_title}</div>
            <div className="text-[11px] text-[hsl(var(--muted-foreground))] flex items-center gap-2">
              <Badge variant={room.status === "playing" ? "default" : "secondary"} className="text-[9px] gap-1 px-1.5 py-0">
                {room.status === "playing" ? <><Play className="w-2 h-2" /> Playing</> : "Lobby"}
              </Badge>
              <span className="flex items-center gap-1"><Users className="w-3 h-3" /> {room.player_count}</span>
              <span className="font-mono tracking-widest">{room.code}</span>
            </div>
          </div>
          <Button size="sm" className="rounded-full h-8 shrink-0" onClick={() => setOpenLobby(true)} data-testid="lobby-dock-open">
            <Maximize2 className="w-3.5 h-3.5 sm:mr-1" /> <span className="hidden sm:inline">Open lobby</span>
          </Button>
          <Radio className="w-4 h-4 text-[hsl(var(--primary))] shrink-0 sm:hidden" />
        </div>
      )}
      <LobbyDialog />
    </>
  );
}
